




































import { Prop, Vue } from "vue-property-decorator";
import Component from "vue-class-component";

@Component({})
export default class Dropdown extends Vue {
  @Prop() title!: string;
  @Prop() dData!: any;
  /*= [
    {
      link: "http://localhost:8080",
      title: "Dummy 1",
      clickevent: "",
      icon: "bi bi-chevron-up",
    },
    { link: "http://localhost:8080", title: "Dummy 2" },
  ];*/
}
